import { UseQueryResult, useQuery } from "@tanstack/react-query";
import UserNotificationMediumResponse from "../../../models/API/responseModels/userNotificationMediumResponse.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

function useUserMediumValues(options?: { enabled?: boolean }): UseQueryResult<UserNotificationMediumResponse> {
  const { authState } = useOktaAuth();

  return useQuery({
    queryKey: ["userNotificationMediums"],
    queryFn: () =>
      axiosInstance
        .get("/v1/user-notification-mediums", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}` || "",
          },
        })
        .then((res) => res.data),
    enabled: !!authState?.accessToken?.accessToken && (options?.enabled ?? true),
  });
}

export default useUserMediumValues;
